<div class="am-close dh" [ngClass]="item.class">
    <vn-icon name="theme-ex" extraClass="" size="16" (click)="close()" />
</div>
